import urls from './restConstants';
import api from './restApi';

const archivedDocumentsCollection = api.all(urls.archivedDocuments);

export default archivedDocumentsCollection;



// WEBPACK FOOTER //
// ./book/src/commons/rest/archivedDocumentsRest.js